import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DispensariesApi } from 'api';
import { MAX_DEPOSIT_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useSetMaxDeposit(dispensaryId: string) {
  const { userBankId } = useUser();
  const dispensariesApi = new DispensariesApi();
  const queryClient = useQueryClient();
  const { mutateAsync: setMaxDeposit, isPending: isSettingMaxDeposit } = useMutation({
    mutationKey: [MAX_DEPOSIT_KEY],
    mutationFn: (value: number) => dispensariesApi.setMaxDeposit(userBankId, dispensaryId, value),
    onSuccess: () => {
      // Max deposit is isolated to the Internal tab — only its own cached read needs refreshing.
      queryClient.invalidateQueries({ queryKey: [MAX_DEPOSIT_KEY, dispensaryId] });
    }
  });
  return { setMaxDeposit, isSettingMaxDeposit };
}
